import React, { Component } from "react";
import SlidingPanel from "react-sliding-side-panel";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import InfoCard from "./InfoCard";
import { estados } from "../../util/estados";
import Graficos from "./Graficos";

class SlidingPanelEmpreendimento extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPaneOpen: props.isOpen,
            isPaneOpenLeft: false,
            panel_empreendimento_visible: this.props.panel_empreendimento_visible,
            estados: estados,
            cidades: [],
            ranges: [],
        };
    }

    componentDidMount() { }

    componentDidUpdate(prevProps) {
        const wasOpen = prevProps.state.isSlideOpen;
        const isOpen = this.props.state.isSlideOpen;
        const overlaysChanged = prevProps.overlays !== this.props.overlays;

        if (isOpen && (!wasOpen || overlaysChanged)) {
            const panelEl = this.el?.closest('.panel');
            if (panelEl) {
                panelEl.scrollTop = 0;
            }
        }
    }

    render = () => {
        let selectedAreas = this.props.overlays;
        const isOpen = this.props.state.isSlideOpen;
        const areasWithUsers = (selectedAreas || []).filter(a => a.users?.length > 0);

        return (
            <div
                className="col-md-4"
                style={{ backgroundColor: "#ffffff", overflow: "scroll", height: 0 }}
            >
                <div ref={(ref) => (this.el = ref)}>
                    <SlidingPanel
                        style={{ backgroundColor: "#ffffff" }}
                        className="some-custom-class"
                        panelContainerClassName="side-panel slider-align"
                        panelClassName=""
                        isOpen={isOpen}
                        title="Informaçoes"
                        size={37}
                        noBackdrop={true}
                        type={"right"}
                    >
                        <div
                            id="card-results"
                            className="card card-results"
                            style={{ marginBottom: 0, paddingTop: 0 }}
                        >
                            <h3 className="sliding-map-title letter-spacing-1">
                                Áreas selecionadas
                            </h3>

                            <div
                                className="card-body"
                                style={{ paddingRight: 15, backgroundColor: "white" }}
                            >
                                    <div className="container" style={{ overflowX: "visible" }}>
                                        <div id="pdf">

                                            {this.props.loadingMetadata && (
                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", width: "100%" }}>
                                                    <img alt="carregando..." src="/img/loader.gif" />
                                                </div>
                                            )}

                                            {!this.props.loadingMetadata && (
                                                <>
                                                    <div className="container-fluid" style={{ display: "flex", justifyContent: "space-between", alignContent: "center", alignItems: "center" }}></div>
                                                    {selectedAreas.map((selectedArea, index) => {
                                                        if (!selectedArea.users?.length) return null;
                                                        const isFirst = selectedAreas.slice(0, index).every(a => !a.users?.length);
                                                        return (
                                                            <div key={`selected-area-${index}`}>
                                                                <InfoCard
                                                                    selectedArea={selectedArea}
                                                                    color={selectedArea.color}
                                                                    type={selectedArea.type}
                                                                    getImageMapaUrl={this.props.getImageMapaUrl}
                                                                    mapScreenCaptureDataForPDF={this.props.state.mapScreenCaptureDataForPDF}
                                                                    showPdfButton={isFirst}
                                                                    allAreas={areasWithUsers}
                                                                />

                                                                <Graficos
                                                                    selectedArea={selectedArea}
                                                                    color={selectedArea.color}
                                                                    areaId={selectedArea.id}
                                                                />
                                                            </div>
                                                        );
                                                    })}
                                                </>
                                            )}

                                        </div>
                                        <hr />
                                    </div>
                                </div>
                            </div>
                    </SlidingPanel>
                </div>
            </div>
        );
    };
}

export default SlidingPanelEmpreendimento;
